import types from './types'

export default {
  [types.RESET]: state => {
    state.statusDashboardItems = void 0
    state.dashboardItems = []
    state.statusItem = void 0
    state.item = {}
  },
  [types.GET_DASHBOARD_LIST.REQUEST]: state => {
    state.statusDashboardItems = 'fetching'
  },
  [types.GET_DASHBOARD_LIST.SUCCESS]: (state, result) => {
    state.statusDashboardItems = 'success'
    state.dashboardItems = result.data
  },
  [types.GET_DASHBOARD_LIST.FAILURE]: state => {
    state.statusDashboardItems = 'failure'
  },
  [types.GET_ITEM.REQUEST]: (state) => {
    state.item = {}
    state.statusItem = 'fetching'
  },
  [types.GET_ITEM.SUCCESS]: (state, result) => {
    state.statusItem = 'success'
    state.item = result.data
  },
  [types.GET_ITEM.FAILURE]: state => {
    state.statusItem = 'failure'
  }
}
